import { useEffect, useState } from "react";
import { pca } from "../config/authConfig";
import { ClaimsUtility } from "../utilities/claimsUtilities";

export interface IAuthenticatedUser {
  name: string;
  email: string;
  companyIds: number[];
  claimsPermissions: Record<number, number[]>;
  externalId: string;
}

export const useAuthenticatedUser = () => {
  const [user, setUser] = useState<IAuthenticatedUser>({
    name: "",
    email: "",
    companyIds: [],
    claimsPermissions: {},
    externalId: "",
  });

  // Register the event callback
  useEffect(() => {
    const callback = (event: any) => {
      const { payload } = event;
      if (!payload?.account) return;

      const { name, username, idTokenClaims } = payload.account;

      setUser((prevUser) => {
        // TODO: The bug causing many components to re-render is because the user object is being recreated
        // presumably unecessarily. I haven't found a fix that works, but I think it will go here and involve
        // checking for equality between the previous and new user objects.
        return {
          name: name,
          email: username,
          companyIds: ClaimsUtility.getUserCompanyIds(idTokenClaims),
          claimsPermissions: ClaimsUtility.getCompanyPermissions(idTokenClaims),
          externalId: ClaimsUtility.getExternalId(idTokenClaims),
        };
      });
    };

    const eventId = pca.addEventCallback(callback);

    // Cleanup on unmount
    return () => {
      if (eventId) pca.removeEventCallback(eventId);
    };
  }, []);

  return user;
};
